import { render, staticRenderFns } from "./AddBin.vue?vue&type=template&id=6c48537f&scoped=true"
import script from "./AddBin.vue?vue&type=script&lang=js"
export * from "./AddBin.vue?vue&type=script&lang=js"
import style0 from "./AddBin.vue?vue&type=style&index=0&id=6c48537f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48537f",
  null
  
)

export default component.exports